import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import LanguageSelector from "../components/LanguageSelector";
import { useTranslation } from "react-i18next";


import {
  FaMobileAlt,
  FaMapMarkerAlt,
  FaPhone,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTiktok,
  FaYoutube,
  FaEnvelope,
} from "react-icons/fa";

import { HiMenu, HiX } from "react-icons/hi"; // ✅ NEW

import headerLogo from "../assets/Images/headerlogo.png";



export default function Header() {
  const { t } = useTranslation(); // ✅ use it
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
  const location = useLocation();

  const navItems = [
{ name: t("home"), path: "/" },
  { name: t("oferta"), path: "/ofertat" },
  { name: t("aboutus"), path: "/about" },
  { name: t("swimming.title"), path: "/packages" },
  { name: t("outdoor"), path: "/outdoor" },
   { name: t("indoor"), path: "/indoor" },
  // { name: "HOTEL & RESTORANT", path: "/hotel-restaurant" },
  // { name: "PAKO", path: "/packages" },
  // { name: "LAJME", path: "/news" },
  { name: t("event"), path: "/events" },
  { name: t("kontakt"), path: "/contact" },
];

useEffect(() => {
  const handleResize = () => {
    const mobile = window.innerWidth <= 1024; // ✅ covers iPad Pro too
    setIsMobile(mobile);
    if (!mobile) setMenuOpen(false);
  };
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

  const handleNavLinkClick = () => {
    if (isMobile) setMenuOpen(false);
  };

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto";
  }, [menuOpen]);

  const contactRowStyle = {
  display: "grid",
  gridTemplateColumns: "20px 1fr",
  alignItems: "center",
  columnGap: "10px",
  textDecoration: "none",
  color: "#111",
  padding: "8px 0",
  direction: "ltr",        // prevents accidental RTL flips
};

const contactIconStyle = { display: "block", justifySelf: "start" };
const contactTextStyle = { fontWeight: 600, lineHeight: 1.2 };


  return (
    <>
      <div className="bg-primary text-white" style={{ backgroundColor: "#2563eb", minHeight: "40px" }}>
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center px-4 py-2">
            <div className="d-flex align-items-center d-none d-md-flex" style={{ gap: "2rem" }}>
              <div className="d-flex align-items-center" style={{ gap: "0.5rem" }}>
  <FaMapMarkerAlt size={14} />
  <a
    href="https://maps.app.goo.gl/fzkR7EcSumteDqMD8"
    target="_blank"
    rel="noopener noreferrer"
    style={{ fontSize: "0.875rem", fontWeight: "500", textDecoration: "none", color: "inherit" }}
  >
    Step Arena
  </a>
</div>

<div className="d-flex align-items-center" style={{ gap: "0.5rem" }}>
  <FaMobileAlt size={14} />
  <a
    href="tel:048334000"
    style={{ fontSize: "0.875rem", fontWeight: "500", textDecoration: "none", color: "inherit" }}
  >
    {t("contactus")}
  </a>
</div>

            </div>
      <div className="d-flex align-items-center" style={{ gap: "1.5rem" }}>
  <div className="d-flex align-items-center" style={{ gap: "0.75rem" }}>
    <a
      href="https://www.facebook.com/share/1D1Vk8gRkd/?mibextid=wwXIfr"
      target="_blank"
      rel="noopener noreferrer"
      className="text-white"
      style={{ opacity: "0.8", transition: "opacity 0.3s" }}
      onMouseOver={e => e.target.style.opacity = "1"}
      onMouseOut={e => e.target.style.opacity = "0.8"}
    >
      <FaFacebookF size={18} />
    </a>
    <a
      href="https://www.instagram.com/stepsportcenter?igsh=eGk4d2Z0NmYyZTdo"
      target="_blank"
      rel="noopener noreferrer"
      className="text-white"
      style={{ opacity: "0.8", transition: "opacity 0.3s" }}
      onMouseOver={e => e.target.style.opacity = "1"}
      onMouseOut={e => e.target.style.opacity = "0.8"}
    >
      <FaInstagram size={18} />
    </a>
    <a
      href="https://www.tiktok.com/@stepsportcenter?_t=ZM-8yUEeHT1Q86&_r=1"
      target="_blank"
      rel="noopener noreferrer"
      className="text-white"
      style={{ opacity: "0.8", transition: "opacity 0.3s" }}
      onMouseOver={e => e.target.style.opacity = "1"}
      onMouseOut={e => e.target.style.opacity = "0.8"}
    >
      <FaTiktok size={18} />
    </a>
      <LanguageSelector />
    
  </div>
</div>

          </div>
        </div>
      </div>

      <nav className="navbar navbar-expand-lg navbar-white bg-white shadow-sm">
        <div className="container-fluid navigation">
        <a href="/" className="navbar-brand">
  <img src={headerLogo} alt="Step Arena Logo" height={50} />
</a>


          {isMobile && (
            <button
              className="custom-toggle-button"
              onClick={() => setMenuOpen(!menuOpen)}
              style={{
                fontSize: '2rem',
                background: 'none',
                border: 'none',
                outline: 'none',
                color: '#000',
                position: 'absolute',
                right: '20px',
                top: '15px',
                zIndex: 1001,
                cursor: 'pointer'
              }}
            >
              {menuOpen ? <HiX /> : <HiMenu />}
            </button>
          )}

          {!isMobile ? (
            <div className="collapse navbar-collapse py-3 py-md-0">
              <div className="d-flex justify-content-center flex-grow-1">
                <ul className="navbar-nav d-flex flex-row gap-4 mb-2 mb-lg-0 menu">
                  {navItems.map((item) => {
                    const isActive = location.pathname === item.path;
                    return (
                      <li className="nav-item" key={item.name}>
                        <Link className="nav-link fw-semibold" to={item.path} onClick={handleNavLinkClick}
                          style={{
                            color: isActive ? "#1D3EE3" : "black",
                            fontWeight: "bold",
                            borderBottom: isActive ? "2px solid #1D3EE3" : "none",
                            WebkitTextFillColor: isActive ? "#1D3EE3" : "black"
                          }}>
                          {item.name}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            <div className="membership">
  <Link
    to="/membership"
    onClick={handleNavLinkClick}
    className="custom-membership-link fw-semibold d-flex align-items-center justify-content-center"
    style={{
      color: location.pathname === '/membership' ? '#1D3EE3' : '#1D3EE3',
      textDecoration: 'none',
    }}
  >
    <span
      style={{
        borderBottom: location.pathname === '/membership' ? '2px solid #1D3EE3' : 'none',
        paddingBottom: '2px',
        fontWeight: 'bold'
      }}
    >
  {t("anetaresim")}
    </span>
  </Link>
</div>

            </div>
          ) : (
    menuOpen && (
  <div className="mobile-menu-overlay">
    {/* ✅ Language selector for mobile */}
    <div className="d-flex justify-content-end px-3 pt-3">
      <LanguageSelector onChanged={() => setMenuOpen(false)} />
    </div>

    <ul className="mobile-nav-links">
      {navItems.map((item) => {
        const isActive = location.pathname === item.path;
        return (
          <li key={item.name}>
            <Link
              to={item.path}
              onClick={handleNavLinkClick}
              style={{
                color: isActive ? "#1D3EE3" : "black",
                fontWeight: "bold",
                fontSize: "1.25rem",
                borderBottom: isActive ? "2px solid #1D3EE3" : "none",
                display: "block",
                padding: "10px 0",
                textAlign: "left",
                paddingLeft: "20px"
              }}
            >
              {item.name}
            </Link>
          </li>
        );
      })}

      <li>
        <Link
          to="/membership"
          onClick={handleNavLinkClick}
          style={{
            fontWeight: "bold",
            fontSize: "1.25rem",
            color: location.pathname === "/membership" ? "#1D3EE3" : "black",
            borderBottom: location.pathname === "/membership" ? "2px solid #1D3EE3" : "none",
            display: "block",
            padding: "10px 0",
            textAlign: "left",
            paddingLeft: "20px"
          }}
        >
          {t("anetaresim")}
        </Link>
      </li>
    </ul>


      {/* Contact block INSIDE the opened menu */}
      <div
        className="mobile-contact"
        style={{
          borderTop: '1px solid #e5e7eb',
          marginTop: '10px',
          padding: '12px 20px 20px'
        }}
      >
        <a
          href="https://maps.app.goo.gl/fzkR7EcSumteDqMD8"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            textDecoration: 'none',
            color: '#111',
            padding: '8px 0'
          }}
          onClick={handleNavLinkClick}
        >
          <FaMapMarkerAlt size={18} style={{ color: '#1D3EE3' }} />
          <span style={{ fontWeight: 600 }}>Step Arena</span>
        </a>

        <a
          href="tel:048334000"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            textDecoration: 'none',
            color: '#111',
            padding: '8px 0'
          }}
          onClick={handleNavLinkClick}
        >
<FaMobileAlt
  size={18}
style={{ color: '#1D3EE3' }}
/>
<span
  style={{ fontWeight: 600, transition: 'color .2s ease' }}
  onMouseEnter={(e) => (e.currentTarget.style.color = '#1D3EE3')}
  onMouseLeave={(e) => (e.currentTarget.style.color = '')} // resets to inherited
>
  048 334 000
</span>

        </a>

        <a
          href="mailto:info@step-ks.com"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            textDecoration: 'none',
            color: '#111',
            padding: '8px 0'
          }}
          onClick={handleNavLinkClick}
        >
          <FaEnvelope size={18}  style={{ color: '#1D3EE3' }}/>
          <span style={{ fontWeight: 600 }}>info@step-ks.com</span>
        </a>
      </div>
    </div>
  )
)}
        </div>
      </nav>
    </>
  );
}
